<template>
  <div>
    <el-form :model="rePwdForm" ref="rePwdForm" label-width="170px" :rules="rules">
      <el-row>
        <el-col>
          <el-form-item label="账户名:">
            {{row.account}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="统一社会信用代码:">
            {{row.uscCode}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="新密码:" prop="newPwd">
            <el-input clearable v-model="rePwdForm.newPwd" style="width:400px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="text-align:center;">
      <el-button @click="$emit('update:visibles',false)">取消</el-button>
      <el-button type="primary" @click="submit()">重置</el-button>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    row: {
      type: Object
    }
  },
  data () {
    return {
      userId: [],
      RoleList: [],
      rePwdForm: {
        newPwd: 'Kaifangbeijing!123'
      },
      rules: {
        newPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: this.validatePass, trigger: ['blur'] }
        ]
      }
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 提交
    submit () {
      this.$refs.rePwdForm.validate((valid) => {
        if (valid) {
          const data = {
            userId: this.row.id,
            newPwd: this.rePwdForm.newPwd
          }
          this.$http.put('/ucenter/user/rePasswordByUserId', this.stringify(data)).then((res) => {
            if (res.status === 200) {
              this.$message.success('成功')
              this.$emit('update:visibles', false)
              this.$emit('Render')
            } else {
              this.$message.error('失败')
              this.$emit('update:visibles', true)
            }
          })
        }
      })
    },
    validatePass (rule, value, callback) {
      if (value === '123') {
        callback()
        return
      }
      if (!/^(?![0-9]+$)(?![^0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z]+$)(?![a-zA-Z0-9]+$)[a-zA-Z0-9\S]{12,30}$/.test(value)) {
        callback(new Error('必须是12-30位包含大小写、数字、特殊字符组合'))
        return
      }
      callback()
    },
    stringify (obj, sep, eq) {
      sep = sep || '&'
      eq = eq || '='
      let str = ''
      for (const k in obj) {
        str += k + eq + decodeURI(obj[k]) + sep
      }
      return str.slice(0, -1)
    }
  },
  watch: {}
}
</script>
<style lang="scss" scoped>

.el-form {
  font-size: 19px;
}

</style>
